import { FilterMenuList, ResetButton } from '@/widgets/map-search-filter'

import { SearchBar } from './search-bar'

export const RoomFilter = () => {
  return (
    <div className="z-filter-bar absolute flex h-[50px] w-full min-w-[1280px] items-center overflow-hidden border-b border-b-gray-100 bg-white pl-6 shadow-[0px_4px_10px_-4px_rgba(0,0,0,0.15)]">
      <SearchBar />
      <FilterMenuList />
      <ResetButton />
    </div>
  )
}
